
import React from 'react';
import Popover from "../popover";
import PopoverMenuContent from "../popover-menu-content";

const PopoverThreeDots = ({ hideArrow = 'true',  placement= 'bottom', options, className, ...props }) => {

    return ( 
        <Popover
            {...props}
            content={<PopoverMenuContent items={options} />}
            hideArrow={hideArrow}
            placement={placement}
            className={className}
        >
            <img className="bimmatch-three-dot" src="/images/icon/threedots.svg" alt="icon" />
        </Popover>
     );
}
 
export default PopoverThreeDots;